import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AUTH_PATHS } from '../auth';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-send-email-success',
  templateUrl: './send-email-success.component.html',
  styleUrls: ['./send-email-success.component.scss'],
  standalone: false,
})
export class SendEmailSuccessComponent implements OnInit {
  public AUTH_PATHS = AUTH_PATHS;
  public recoveryAccessSuccessBreadcrumbs: Breadcrumb[] = [{ text: 'Восстановление доступа', url: null }];
  public email: string | Observable<any>;

  constructor(
    private route: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService
  ) {
    this.email = this.route.queryParamMap.pipe(map((params) => params.get('email') || ''));
  }

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.recoveryAccessSuccessBreadcrumbs);
  }
}
